import i18n from 'i18next'

export const shouldSignOutForStatus = status => status === 401

const fallbackText = {
  'http.authenticationFail': 'Authentication failed',
  'http.loginAgain': 'Please log in again',
  'http.invalidRequest': 'Invalid request',
  'http.checkFormValues': 'Please check the form values and try again',
  'route.forbiddenTitle': 'No access',
  'http.forbiddenActionDescription': 'Your current account is not allowed to perform this action.',
  'http.notFound': 'Not Found',
  'http.internalServerError': 'Internal Server Error',
  'http.timeOut': 'Time Out',
  'http.error': 'Error',
}

const translate = key => {
  const translated = i18n.t(key)
  return translated && translated !== key ? translated : fallbackText[key]
}

const normalizeServerMessage = data => {
  const message = data?.message
  if (Array.isArray(message)) return message.join('\n')
  if (message) return String(message)
  if (data?.error) return String(data.error)
  return undefined
}

export const getNotificationForStatus = (status, data) => {
  const serverMessage = normalizeServerMessage(data)

  if (status === 401) {
    return {
      message: translate('http.authenticationFail'),
      description: translate('http.loginAgain'),
    }
  }

  if (status === 400) {
    return {
      message: translate('http.invalidRequest'),
      description: serverMessage || translate('http.checkFormValues'),
    }
  }

  if (status === 403) {
    return {
      message: translate('route.forbiddenTitle'),
      description: translate('http.forbiddenActionDescription'),
    }
  }

  if (status === 404) return { message: translate('http.notFound') }
  if (status === 500) return { message: translate('http.internalServerError') }
  if (status === 508) return { message: translate('http.timeOut') }

  return { message: translate('http.error') }
}
